<template>
  <div class="national-login">
    <div class="ipt-group" :class="{ error: $v.form.account.$error }">
      <input type="text" v-model.trim="form.account" autocomplete="off" @change="resetErrorTips">
      <p class="sub-text" :class="{ 'has-text': form.account }" @click="focusInput">报名ID</p>
      <div class="line" :style="'background:' + $store.state.theme.themeColor"></div>
      <vd-tips path="form.account" class="error-tip" />
    </div>
    <div class="ipt-group mb60" :class="{ error: $v.form.username.$error }">
      <input v-model.trim="form.username" @change="resetErrorTips">
      <p class="sub-text" :class="{ 'has-text': form.username }" @click="focusInput">学生姓名</p>
      <div class="line" :style="'background:' + $store.state.theme.themeColor"></div>
      <vd-tips path="form.username" class="error-tip" />
    </div>
    <div v-if="showErrorTips" class="error-msg">输入信息有误，请核实后重新输入!</div>
    <countdown-btn el="button" type="submit" class="login-btn"
      :style="'background:' + theme.buttonBackground + 'box-shadow: ' + theme.buttonShadow" placeholder="登录"
      lockTmp="登录中..." clickTips="请稍后" @click="onCaptcha"></countdown-btn>
  </div>
</template>

<script>
import { Base64 } from 'js-base64'
import { required, validationMixin } from '@/utils/mixin_validate'
import CountdownBtn from '@/components/CountdownBtn'
import tips from '@/assets/json/errorTips'

/**
 * 新国赛登陆
 */
export default {
  name: 'NationalLogin',
  components: {
    CountdownBtn
  },
  mixins: [validationMixin()],
  validations() {
    // 定义检验规则时注意顺序，弹窗模式时将按顺序弹窗
    return {
      form: {
        account: {
          required
        },
        username: {
          required
        }
      }
    }
  },
  validators: {
    // 这里定义错误提示，与validations结构一一对应
    form: {
      account: {
        required: '请输入报名ID'
      },
      username: {
        required: '请输入学生姓名'
      }
    }
  },
  data() {
    return {
      form: {
        account: '',
        username: ''
      },
      showErrorTips: false
    }
  },
  computed: {
    theme() {
      return this.$store.state.theme
    }
  },
  methods: {
    focusInput(e) {
      e.target.previousSibling.focus()
    },
    // 重置错误
    resetErrorTips() {
      this.$emit('resetError')
    },
    // 图形化验证
    async onCaptcha(lock, reset) {
      try {
        await this.validationTouch()
        lock()
        const identity = `hxth${this.form.account.trim()}`
        // 弹出验证码
        this.$verify({
          identity: identity,
          scene: 'login',
          dom_id: 'countdownBtn',
          success_callback: (ticket) => this.login(ticket, reset),
          fail_callback: reset,
          close_callback: reset
        })
      } catch (e) {
        reset()
      }
    },
    // 账号登录，成功获取通用图形验证码ticket，登录
    async login(ticket, reset) {
      const { account, username } = this.form
      const params = {
        account: `hxth${account.trim()}`,
        password: Base64.encode(username.trim())
      }
      try {
        await this.$auth('login_account_ticket', ...[params.account, params.password, 'egLIJPgY', ticket])
        localStorage.setItem('currentAccount', account)
        this.$emit('success')
        reset()
      } catch (e) {
        this.$emit('fail', e)
        reset()
        if (e === 'USER_NOT_EXIST_OR_PWD_WRONG') {
          this.showErrorTips = true
        } else {
          if (tips[e] === 'Network Error') {
            this.$message.error('网络异常')
          } else {
            const tip = tips[e] || e || '未知错误，重新登录或联系管理员'
            this.$message.error(tip)
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.national-login {
  ::v-deep {
    @import "./index.scss";
  }
}
</style>
